import { render, staticRenderFns } from "./TitledModalSection.vue?vue&type=template&id=34718fa0&scoped=true"
import script from "./TitledModalSection.vue?vue&type=script&lang=ts"
export * from "./TitledModalSection.vue?vue&type=script&lang=ts"
import style0 from "./TitledModalSection.vue?vue&type=style&index=0&id=34718fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34718fa0",
  null
  
)

export default component.exports